import React from 'react';
import api from 'src/services/api';
 
import Whatsapp from 'src/components/Whatsapp';
 
import { FaWhatsapp } from 'react-icons/fa';
import { useModal } from 'src/hooks/Modal';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {
const {addModal} = useModal();

  const sendMessage = async () => {


    const item = await api.get(`/cientific-submissions/${lineData?._id}`)
const student = await api.get(`/students/${item?.data?.client_id}`)

    let text = '';

    if(item?.data?.status_name === 'Aprovado'){
      text = `Olá, *${student?.data?.name}*, o seu trabalho *${item?.data?.title}* foi aprovado no 10º Congresso Brasileiro de Medicina Hiperbárica. Conforme o edital, as apresentações orais terão 8 (oito) minutos de duração, seguidas de 2 (dois) minutos para comentários ou discussão. O material audiovisual necessário à apresentação deverá ser entregue até o dia *07/10/2025*, para o e-mail: cbmh@sbmhcongresso.com.br.`;
    }
    else if(item?.data?.status_name === 'Não aprovado'){
      text = `Olá, *${student?.data?.name}*,infelizmente o seu trabalho *${item?.data?.title}* , submetido no 10º Congresso Brasileiro de Medicina Hiperbárica, não foi aprovado pela comissão avaliadora do evento, para eventuais dúvida, envie um e-mail para cbmh@sbmhcongresso.com.br.`;
    }


    addModal({title: '', content: <div className='column'>

<p>{text || 'Não avaliado'}</p>

{text ? <Whatsapp message="Enviar" text={text} number={`55${student?.data.phone.toString().replace(/[^0-9]/g, '')}`} /> : <></>}
    </div>})

  }





  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
  <button className='lineIcon' onClick={() => {sendMessage()}}> <FaWhatsapp/></button>
  );

  return moduleUpdate(lineData);
}
